import { useMemo, type CSSProperties } from 'react';
import { useLocation } from 'react-router';
import {
    ARTICLE_HERO_TRANSITION_NAME,
    getPendingHeroImage,
    useTileHeroViewTransitionStyle,
} from '@rocco/ui/tile-shared/hooks/use-tile-hero-view-transition';

/**
 * Style for the article's opening picture, the directory tile's counterpart.
 *
 * Matching on this page's own path names the picture for transitions arriving
 * here and for transitions leaving here (Back to the directory flies it into
 * its tile again), and leaves it unnamed for navigations that have nothing to
 * do with this article.
 */
export const useArticleDetailHeroStyle = (): CSSProperties | undefined => {
    const { pathname } = useLocation();
    return useTileHeroViewTransitionStyle(
        pathname,
        ARTICLE_HERO_TRANSITION_NAME,
    );
};

/**
 * The rendition the clicked tile was showing, when this page was reached from
 * one. Already decoded, so it can be painted under the opening picture until
 * the larger rendition arrives; null on full loads and on navigations that
 * did not start from a tile.
 */
export const useArticleArrivalImage = (): string | null => {
    const { pathname } = useLocation();
    return useMemo(() => getPendingHeroImage(pathname), [pathname]);
};
